import SuperTokens from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';
import EmailPassword from 'supertokens-auth-react/recipe/emailpassword';
import ThirdParty from 'supertokens-auth-react/recipe/thirdparty';
import Passwordless from 'supertokens-auth-react/recipe/passwordless';

// Get environment variables
const apiDomain = import.meta.env.VITE_API_URL || 'http://localhost:4000';
const websiteDomain = typeof window !== 'undefined'
  ? window.location.origin
  : (import.meta.env.VITE_WEBSITE_URL || 'http://localhost:3000');

/**
 * Initialize SuperTokens for the frontend
 */
export function initSuperTokens() {
  SuperTokens.init({
    appInfo: {
      appName: 'Wandool',
      apiDomain,
      websiteDomain,
      apiBasePath: '/api/auth',
      websiteBasePath: '/',
    },
    recipeList: [
      ThirdParty.init({
        signInAndUpFeature: {
          providers: [
            ThirdParty.Google.init(),
          ],
        },
      }),
      EmailPassword.init({
        signInAndUpFeature: {
          signUpForm: {
            formFields: [
              {
                id: 'firstName',
                label: 'First Name',
                placeholder: 'Enter your first name',
              },
              {
                id: 'lastName',
                label: 'Last Name',
                placeholder: 'Enter your last name',
              },
              {
                id: 'email',
                label: 'Email',
                placeholder: 'Enter your email',
              },
              {
                id: 'password',
                label: 'Password',
                placeholder: 'Enter your password',
              },
            ],
          },
        },
        style: `
          [data-supertokens~=container] {
            font-family: system-ui, -apple-system, sans-serif;
          }
          [data-supertokens~=button] {
            background-color: #6366f1;
            border-color: #6366f1;
          }
          [data-supertokens~=button]:hover {
            background-color: #4f46e5;
            border-color: #4f46e5;
          }
          [data-supertokens~=superTokensBranding] {
            display: none;
          }
        `,
      }),
      Passwordless.init({
        contactMethod: 'EMAIL',
      }),
      Session.init({
        tokenTransferMethod: 'header',
      }),
    ],
  });
}

/**
 * Get the session access token for API calls
 */
export async function getAccessToken(): Promise<string | undefined> {
  if (await Session.doesSessionExist()) {
    return Session.getAccessToken();
  }
  return undefined;
}

/**
 * Check if user is authenticated
 */
export async function isAuthenticated(): Promise<boolean> {
  return Session.doesSessionExist();
}

/**
 * Sign out the current user
 */
export async function signOut(): Promise<void> {
  await Session.signOut();
}

/**
 * Get user ID from session
 */
export async function getUserId(): Promise<string | undefined> {
  if (await Session.doesSessionExist()) {
    return Session.getUserId();
  }
  return undefined;
}

/**
 * Get access token payload (includes custom claims)
 */
export async function getAccessTokenPayload(): Promise<Record<string, unknown> | undefined> {
  if (await Session.doesSessionExist()) {
    return Session.getAccessTokenPayloadSecurely();
  }
  return undefined;
}
